import {NgModule}                           from '@angular/core';
import {ApLoginComponent}                   from './components/ap-login.component';
import {ButtonModule, DropDownButtonModule} from '@progress/kendo-angular-buttons';
import {InputsModule}                       from '@progress/kendo-angular-inputs';
import {DropDownsModule}                    from '@progress/kendo-angular-dropdowns';
import {CommonModule}                       from '@angular/common';
import {LayoutModule}                       from '@progress/kendo-angular-layout';
import {ApIconModule}                       from '../icons/ap-icon.module';
import {ApRequestPasswordResetComponent}    from './components/ap-request-password-reset.component';
import {ApPasswordRecoveryComponent}        from './components/ap-password-recovery.component';
import {ApContactComponent}                 from './components/ap-contact.component';
import {ApTranslationModule}                from '../translation/ap-translation.module';
import {FormsModule, ReactiveFormsModule}   from '@angular/forms';
import {ApCoreModule}                       from '../ap-core/ap-core.module';
import {ApLoginRoutes}                      from './ap-login.routes';
import {DatePickerModule}                   from '@progress/kendo-angular-dateinputs';
import {ApDynformsModule}                   from '../ap-dynforms/ap-dynforms.module';
import {ApInvitationsComponent}             from './components/ap-invitations.component';
import {ApInvitationsNewUserComponent}      from './components/ap-invitations-new-user.component';
import {ApImprintComponent}                 from './components/ap-imprint.component';
import {ProgressBarModule}                  from '@progress/kendo-angular-progressbar';
import {CountdownModule}                    from 'ngx-countdown';
import {ApResponsiveTextModule}             from '../ap-responsive-text/ap-responsive-text.module';

@NgModule({
  declarations: [
    ApLoginComponent,
    ApRequestPasswordResetComponent,
    ApPasswordRecoveryComponent,
    ApContactComponent,
    ApInvitationsComponent,
    ApInvitationsNewUserComponent,
    ApImprintComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CommonModule,
    InputsModule,
    LayoutModule,
    ApCoreModule,
    ApIconModule,
    ApTranslationModule,
    DropDownsModule,
    DropDownButtonModule,
    ApLoginRoutes,
    DatePickerModule,
    ApDynformsModule,
    ProgressBarModule,
    CountdownModule,
    ApResponsiveTextModule
  ],
  exports: [
    ApLoginComponent,
    ApRequestPasswordResetComponent,
    ApPasswordRecoveryComponent,
    ApContactComponent,
    ApInvitationsComponent,
    ApInvitationsNewUserComponent,
    ApImprintComponent
  ]
})
export class ApLoginModule {
}
